import { useState } from "react";

interface VerbIconProps {
  verb: string;
  size?: number;
  disabled?: boolean;
  locked?: boolean;
  lockReason?: string;
  onClick: () => void;
}

export function VerbIcon({ verb, size = 14, disabled = false, locked = false, lockReason, onClick }: VerbIconProps) {
  const [imgError, setImgError] = useState(false);
  const inactive = disabled || locked;
  const iconName = verb.toLowerCase();

  return (
    <button
      onClick={() => !inactive && onClick()}
      disabled={inactive}
      title={locked && lockReason ? lockReason : locked ? `${verb} (locked)` : verb}
      className="theme-button"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "22px",
        height: "22px",
        cursor: inactive ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : locked ? 0.7 : 1,
        border: locked ? "1px solid rgba(255, 180, 80, 0.4)" : undefined,
        padding: 0,
        flexShrink: 0,
      }}
    >
      {!imgError ? (
        <img
          src={`/chrome/action_icons/${iconName}.svg`}
          alt=""
          onError={() => setImgError(true)}
          className={`verb-icon-img ${disabled ? "disabled" : ""} ${locked ? "locked" : ""}`}
          style={{ width: size, height: size }}
        />
      ) : (
        <span style={{ fontSize: "0.6rem", fontWeight: "bold" }}>
          {verb[0].toUpperCase()}
        </span>
      )}
    </button>
  );
}
